"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdKey = exports.parseContentRangeHeader = exports.getPluralName = exports.getGerundName = exports.upperSnakeCase = exports.ucfirst = exports.endsWith = exports.startsWith = exports.mergeObjects = exports.mapObject = exports.find = exports.pick = exports.isFunction = exports.isObject = exports.isString = exports.includes = void 0;

var _defaults = require("../defaults");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var includes = function includes(array, key) {
  return array.indexOf(key) !== -1;
};

exports.includes = includes;

var isString = function isString(maybeString) {
  return typeof maybeString === 'string';
};

exports.isString = isString;

var isObject = function isObject(maybeObject) {
  return _typeof(maybeObject) === 'object';
};

exports.isObject = isObject;

var isFunction = function isFunction(maybeFunction) {
  return typeof maybeFunction === 'function';
};

exports.isFunction = isFunction;

var pick = function pick(obj) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  return keys.reduce(function (soFar, key) {
    if (includes(keys, key) && obj[key] !== undefined) {
      soFar[key] = obj[key]; // eslint-disable-line no-param-reassign
    }

    return soFar;
  }, {});
};

exports.pick = pick;

var find = function find(collection, query) {
  var queryKeys = Object.keys(query);
  var foundItem;
  collection.some(function (item) {
    var doesMatch = !queryKeys.some(function (key) {
      return item[key] !== query[key];
    });

    if (doesMatch) {
      foundItem = item;
    }

    return doesMatch;
  });
  return foundItem;
};

exports.find = find;

var mapObject = function mapObject(object, func) {
  return Object.keys(object).reduce(function (soFar, key) {
    soFar[key] = func(object[key]); // eslint-disable-line no-param-reassign

    return soFar;
  }, {});
};

exports.mapObject = mapObject;

var mergeObjects = function mergeObjects(object) {
  for (var _len2 = arguments.length, sources = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    sources[_key2 - 1] = arguments[_key2];
  }

  var concat = Array.prototype.concat;
  var uniqueKeys = concat.apply(Object.keys(object), sources.map(Object.keys)).filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
  return uniqueKeys.reduce(function (soFar, key) {
    soFar[key] = Object.assign.apply(Object, [soFar[key] || {}].concat(_toConsumableArray(sources.map(function (source) {
      return source[key] || {};
    })))); // eslint-disable-line no-param-reassign

    return soFar;
  }, object);
};

exports.mergeObjects = mergeObjects;

var startsWith = function startsWith(string, target) {
  return String(string).slice(0, target.length) === target;
};

exports.startsWith = startsWith;

var endsWith = function endsWith(string, target) {
  return String(string).slice(string.length - target.length) === target;
};

exports.endsWith = endsWith;

var ucfirst = function ucfirst(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
};

exports.ucfirst = ucfirst;

var upperSnakeCase = function upperSnakeCase(string) {
  return String(string.split('').reduce(function (soFar, letter, index) {
    var charCode = letter.charCodeAt(0);
    return soFar + (index && charCode < 97 ? "_".concat(letter) : letter).toUpperCase();
  }, ''));
};

exports.upperSnakeCase = upperSnakeCase;

var getGerundName = function getGerundName(name) {
  return "".concat(name.replace(/e$/, ''), "ing");
};

exports.getGerundName = getGerundName;

var getPluralName = function getPluralName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return name.endsWith('s') ? name : "".concat(name, "s");
};

exports.getPluralName = getPluralName;

var parseContentRangeHeader = function parseContentRangeHeader(string) {
  if (typeof string === 'string') {
    var matches = string.match(/^(\w+) (\d+)-(\d+)\/(\d+|\*)/);

    if (matches) {
      return {
        unit: matches[1],
        first: +matches[2],
        last: +matches[3],
        length: matches[4] === '*' ? null : +matches[4]
      };
    }
  }

  return null;
};

exports.parseContentRangeHeader = parseContentRangeHeader;

var getIdKey = function getIdKey(action, _ref) {
  var _ref$multi = _ref.multi,
      multi = _ref$multi === void 0 ? false : _ref$multi;
  return multi ? _defaults.defaultIdKeys.plural : _defaults.defaultIdKeys.singular;
};

exports.getIdKey = getIdKey;